import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "aria-selected", "aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "day"
}
const _hoisted_3 = {
  key: 2,
  class: "date"
}
const _hoisted_4 = {
  key: 4,
  class: "month"
}

import { Skeletor } from 'vue-skeletor';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselDateItem',
  props: {
    active: { type: Boolean },
    disabled: { type: Boolean },
    dayOfWeek: {},
    fullDayOfWeek: {},
    dayOfMonth: {},
    month: {},
    fullMonth: {},
    onClick: { type: Function },
    isLoading: { type: Boolean },
    hasSailings: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    disabled: _ctx.disabled,
    "aria-selected": _ctx.active,
    class: _normalizeClass({ active: _ctx.active, 'no-sailings': _ctx.hasSailings === false && !_ctx.active && !_ctx.disabled }),
    "aria-label": `${_ctx.fullDayOfWeek} ${_ctx.dayOfMonth} ${_ctx.fullMonth}`,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.dayOfWeek), 1))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_unref(Skeletor), {
            key: 1,
            class: "vue-skeletor-day"
          }))
        : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.dayOfMonth), 1))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_unref(Skeletor), {
            key: 3,
            class: "vue-skeletor-date"
          }))
        : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.month), 1))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_unref(Skeletor), {
            key: 5,
            class: "vue-skeletor-month"
          }))
        : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})